import React, {Component} from 'react'
import {cardStyles, styles} from '../Constants'
import {Card, CardActions, CardHeader, CardText} from 'material-ui/Card'
import FlatButton from 'material-ui/FlatButton'
import Toggle from 'material-ui/Toggle'
import Paper from 'material-ui/Paper'
import IconMenu from 'material-ui/IconMenu'
import MenuItem from 'material-ui/MenuItem'
import IconButton from 'material-ui/IconButton'
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert'

import * as firebase from 'firebase'

export default class DaySchedule extends Component {
  constructor(props) {
    super(props)
    this.state = {
      childrenData: [],
    }
  }

  applyReward() {
    console.log("Reward Applied")
  }

  signInOut = () => {
    let self = this
    firebase.auth().signOut().then(function() {
      window.location.href = "./"
    }, function(error) {
      console.error('Sign Out Error', error);
    })
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (nextProps.theDay.length != 0 || nextState.childrenData.length != 0)
  }

  getAJAXData(nextProps) {
    let self = this
    var date = nextProps.theDay[0]
    date = date.split("-")
    let year = parseInt(date[0])
    let month = parseInt(date[1]) - 1
    let aDay = parseInt(date[2])
    firebase.database().ref("schedules/" + year + "/" + month + "/" + aDay + "/")
    .on("value", function(snap) {
      let lst = []
      if(snap.val()) {
        snap.forEach(function(child) {
          let item = child.val()
          item.key = child.key
          lst.push(item);
        })
      }
      self.setState({childrenData: lst})
    })
  }

  componentDidMount() {
    this.getAJAXData(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getAJAXData(nextProps)
  }

  render() {
    let self = this
    return (
      <div>
      <CardText
        expandable={true}>
        {self.state.childrenData.length == 0 ? null :
          <h4 id="theMessage" className="center">Appointments</h4>
        }
        {self.state.childrenData.map(function(o) {
          return (
            <Card key={o.key} zDepth={2}>
              <CardHeader
                title={o.userName}
                subtitle={o.date + " at " + o.time}
                avatar={o.storageRef}/>
                <IconMenu className="right"
                  listStyle={{backgroundColor: '#251B32'}}
                  menuItemStyle={{color: '#DCA3AC'}}
                  iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}
                  anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                  targetOrigin={{horizontal: 'right', vertical: 'bottom'}}>
                  <MenuItem
                    primaryText="Apply Reward"
                    onClick={self.applyReward.bind(this)}/>
                </IconMenu>
                <p style={{paddingBottom: '5px'}}>
                  &nbsp;&nbsp;&nbsp;&nbsp;{o.name}
                  <br/>
                  &nbsp;&nbsp;&nbsp;&nbsp;{o.status}
                </p>
            </Card>
          )
        })}
      </CardText>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/react/DaySchedule.js